import { render, staticRenderFns } from "./VideoCallButton.vue?vue&type=template&id=7b89f3d8&"
import script from "./VideoCallButton.vue?vue&type=script&lang=js&"
export * from "./VideoCallButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports